import React, { useRef } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import { Box } from '@features/story/components/Box'
import { Button } from '@components/Buttons'
import { UserAvatarRank } from '@components/UserAvatarRank'
import { BookSupporterType } from '@models/book/BookSupporterType'
import { useDraggable } from '@hooks/draggableScroll/useDraggable'
import { PayRankProps } from './interface'

const PayRank = ({
  supporters,
  isDrawer,
  className,
  handleViewAll,
}: PayRankProps) => {
  const ref =
    useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>
  const { events } = useDraggable(ref)
  return (
    <Box className={cn('card dark:border-purple', className)}>
      <Box.Title className='text-2xl px-[30px] dark:text-dark-10'>
        อันดับสายเปย์
      </Box.Title>
      {!!supporters?.length && (
        <div
          className={cn(
            'flex pt-[20px] pb-[30px] pl-[30px] mobile:pt-[10px] mobile:pl-[20px] overflow-x-auto scrollbar-none scrollbar-none::-webkit-scrollbar',
            {
              'space-x-[37px]': !isDrawer,
              'space-x-[30px]': isDrawer,
            }
          )}
          {...events}
          ref={ref}
        >
          {supporters.map((item: BookSupporterType, i: number) => (
            <div className='flex flex-col items-center' key={item.id}>
              <UserAvatarRank
                className='w-[50px] h-[50px]'
                rank={i + 1}
                slug={item.profilePageSlug}
                src={item.avatarImgPath}
                alt={item.displayName}
                width={50}
                height={50}
              />
              <Link href={`/profile/${item.profilePageSlug}`} prefetch={false}>
                <a className='font-bold text-sm text-secondary-1 mt-[5px] text-center hover:underline w-[76px] truncate'>
                  {item.displayName}
                </a>
              </Link>
              <span className='font-light text-xs text-secondary-1 mt-[2px] text-center w-[76px] truncate'>
                @{item.username}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className='flex justify-center'>
        <Button
          type='button'
          className='border border-secondary dark:border-dark-10 w-[154px]'
          onClick={handleViewAll}
        >
          <span className='font-mitr text-secondary dark:text-dark-10 text-sm font-medium'>
            ผู้สนับสนุนทั้งหมด
          </span>
        </Button>
      </div>
    </Box>
  )
}

export { PayRank }
